export const moduleNamespace = 'venus';
export const routeNamespace = '/deterioration';
